import { render, staticRenderFns } from "./ib-table.vue?vue&type=template&id=6a73afcb&lang=pug&"
import script from "./ib-table.vue?vue&type=script&lang=js&"
export * from "./ib-table.vue?vue&type=script&lang=js&"
import style0 from "./ib-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a73afcb')) {
      api.createRecord('6a73afcb', component.options)
    } else {
      api.reload('6a73afcb', component.options)
    }
    module.hot.accept("./ib-table.vue?vue&type=template&id=6a73afcb&lang=pug&", function () {
      api.rerender('6a73afcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/ib-table.vue"
export default component.exports